// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"0":"e9fc7aa0","20":"284a32cf","701":"27b3056d"}[chunkId] + ".css";
};